<div class="access-denied">
    <h1>ACESSO NEGADO</h1>
    <p>Você não tem permissão para acessar esta página.</p>
</div>